module.exports = __webpack_public_path__ + "media/images/icons/icon-info-7154c4cb31baabcbbd2f452fb59ed097.svg";